module.exports = __webpack_public_path__ + "b129b23599b45743886331450735e5d6.svg";